import { CriteriaType } from '../../../reward-tokens/reward-tokens.model';
import { BetPlacementErrorIcon } from '../bet-placement-error-icon';
import { BetslipError } from '../betslip-error';
import { ClientErrorType } from '../client-error-type';
import { PreCheckErrorMixin } from '../pre-check/pre-check-error';

export class RewardTokensTradingEntityMismatchError extends PreCheckErrorMixin(BetslipError) {
    constructor(criteriaType: CriteriaType, entityNames: { name: string }[]) {
        super();
        this.icon = BetPlacementErrorIcon.Error;
        this.type = ClientErrorType.RewardTokensTradingEntityMismatchError;
        this.hasClientValidation = true;
        this.criteriaType = criteriaType;
        this.entityNames = entityNames;
    }

    readonly criteriaType: CriteriaType;
    readonly entityNames: { name: string }[];
}
